class Device {
  width () {
    return window.screen.width
  }

  height () {
    return window.screen.height
  }

  isDesktop () {
    return this.width() >= 1440 && this.height() >= 900
  }

  isTablet () {
    return !this.isDesktop() && this.width() >= 960 && this.height() >= 700
  }

  isMobile () {
    return !this.isDesktop() && !this.isTablet()
  }
}

export default new Device()
